import { render, staticRenderFns } from "./app-company.vue?vue&type=template&id=49b1516a&scoped=true&"
import script from "./app-company.vue?vue&type=script&lang=js&"
export * from "./app-company.vue?vue&type=script&lang=js&"
import style0 from "./app-company.vue?vue&type=style&index=0&id=49b1516a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1516a",
  null
  
)

export default component.exports